import React, { Component } from 'react';
import animations from './animations';
import SlideForm from "../../forms/SlideForm/SlideForm";
import SlideFormErrorBoundary from "../SlideFormErrorBoundary";
import globals from '../../globals';

/*
    To call the animateIn method from outside of this component you may use:
    <YourElement onClick={(event) => window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null} />
    OR
    <Button action={(event) => window.slideFormContainer ? window.slideFormContainer.animateIn(event) : null} image="/images/btn-enquire-now-darkgreen.svg" />
*/
class SlideFormContainer extends Component {

    animateOut(event) {
        event.preventDefault();
        animations.animateOut(this);
    }

    animateIn(event) {
        event.preventDefault();
        globals.pushEvent('contactFormOpen');
		globals.pushHJEvent('/contactFormOpen');
        animations.animateIn(this);
    }

    handleCloseHover(event) {
        animations.animateButton(event.currentTarget);
    }

    render() {
        return (
            <section className="slide-form">
                <div className="slide-form-bg-img" />
                <div className="slide-form-bg" />
                <div className="slide-form-inner">
                    <a href="#" className="do-close-slideform" onMouseEnter={this.handleCloseHover.bind(this)} onClick={(event) => this.animateOut(event)} title="Close" />
                    <SlideFormErrorBoundary>
                        <div className="row heading">
                            <div className="col-xs-12 col-sm-9">
                                <h2>Contact us</h2>
                                <p>Let us call you. One of our Telecommunications Consultants will gladly answer any questions you might have, or organise an obligation free quote.</p>
                            </div>
                        </div>
                        <SlideForm ref={el => this.slideFormRef = el} />
                    </SlideFormErrorBoundary>
                </div>
            </section>
        );
    }
    
}

export default SlideFormContainer;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/SlideFormContainer/SlideFormContainer.js